import {
  GET_AI_TRAINING,
  GET_AI_TRAINING_SUCCESS,
  GET_AI_TRAINING_FAIL,
  GET_AI_TRAINING_BY_ID,
  GET_AI_TRAINING_BY_ID_SUCCESS,
  GET_AI_TRAINING_BY_ID_FAIL,
  GET_AI_TRAINING_CATEGORIES,
  GET_AI_TRAINING_CATEGORIES_SUCCESS,
  GET_AI_TRAINING_CATEGORIES_FAIL,
  UPSERT_AI_TRAINING,
  UPSERT_AI_TRAINING_SUCCESS,
  UPSERT_AI_TRAINING_FAIL,
  DELETE_AI_TRAINING,
  DELETE_AI_TRAINING_SUCCESS,
  DELETE_AI_TRAINING_FAIL,
  RESET_AI_TRAINING_FLAG,
} from "./actionTypes"

// Get All AI Training Data
export const getAiTraining = (activeOnly = false, category = '') => ({
  type: GET_AI_TRAINING,
  payload: { activeOnly, category },
})

export const getAiTrainingSuccess = data => ({
  type: GET_AI_TRAINING_SUCCESS,
  payload: data,
})

export const getAiTrainingFail = error => ({
  type: GET_AI_TRAINING_FAIL,
  payload: error,
})

// Get AI Training By ID
export const getAiTrainingById = id => ({
  type: GET_AI_TRAINING_BY_ID,
  payload: id,
})

export const getAiTrainingByIdSuccess = data => ({
  type: GET_AI_TRAINING_BY_ID_SUCCESS,
  payload: data,
})

export const getAiTrainingByIdFail = error => ({
  type: GET_AI_TRAINING_BY_ID_FAIL,
  payload: error,
})

// Get Categories
export const getAiTrainingCategories = () => ({
  type: GET_AI_TRAINING_CATEGORIES,
})

export const getAiTrainingCategoriesSuccess = categories => ({
  type: GET_AI_TRAINING_CATEGORIES_SUCCESS,
  payload: categories,
})

export const getAiTrainingCategoriesFail = error => ({
  type: GET_AI_TRAINING_CATEGORIES_FAIL,
  payload: error,
})

// Upsert (Create/Update)
export const upsertAiTraining = data => ({
  type: UPSERT_AI_TRAINING,
  payload: data,
})

export const upsertAiTrainingSuccess = (data, isUpdate) => ({
  type: UPSERT_AI_TRAINING_SUCCESS,
  payload: { data, isUpdate },
})

export const upsertAiTrainingFail = error => ({
  type: UPSERT_AI_TRAINING_FAIL,
  payload: error,
})

// Delete
export const deleteAiTraining = id => ({
  type: DELETE_AI_TRAINING,
  payload: id,
})

export const deleteAiTrainingSuccess = id => ({
  type: DELETE_AI_TRAINING_SUCCESS,
  payload: id,
})

export const deleteAiTrainingFail = error => ({
  type: DELETE_AI_TRAINING_FAIL,
  payload: error,
})

// Reset Flag
export const resetAiTrainingFlag = () => ({
  type: RESET_AI_TRAINING_FLAG,
})
